import { WorkflowTemplateStatus } from '../Types'

const product: WorkflowTemplateStatus = {
  configuration: {
    '936b67b6-35ca-4519-9295-d1a91e3dae01': {
      exit: [],
      entry: [],
    },
    '82aaf084-6d3e-4efa-ba04-bcb0c9d39791': {
      exit: [
        {
          type: 'reviews.close',
          config: {},
        },
      ],
      entry: [
        {
          type: 'reviews.create',
          config: {},
        },
      ],
    },
    '70d92660-1e3b-4451-a9ab-9a9b8dbe8409': {
      exit: [],
      entry: [],
    },
    'd8b39b11-3a49-4b82-a60e-e2ec122374e6': {
      exit: [],
      entry: [],
    },
  },
  property_values: [
    {
      uuid: '936b67b6-35ca-4519-9295-d1a91e3dae01',
      value: 'Draft',
      meta: {
        color: '#E5ECF3',
      },
      position: 0,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: '82aaf084-6d3e-4efa-ba04-bcb0c9d39791',
      value: 'Review',
      meta: {
        color: '#EBDCFF',
      },
      position: 1,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: '70d92660-1e3b-4451-a9ab-9a9b8dbe8409',
      value: 'Reviewed',
      meta: {
        color: '#8626FF',
      },
      position: 2,
      connected_to_uuid: '82aaf084-6d3e-4efa-ba04-bcb0c9d39791',
      connected_to_id: null,
    },
    {
      uuid: 'd8b39b11-3a49-4b82-a60e-e2ec122374e6',
      value: 'Final',
      meta: {
        color: '#028C3A',
      },
      position: 5,
      connected_to_uuid: null,
      connected_to_id: null,
    },
  ],
}

export default product
